export default __webpack_public_path__ + "static/media/settings_1.39ad77bd.svg";